import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { NotificationManager } from "react-notifications";
import CommonLoader from "../common/CommonLoader";
import { ApplyPaymentsToInvoice } from "../../services/InvoiceService";

const ApplyPaymentsDialog = ({ open, onClose, onApply }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setStartDate(formattedDate);
    setEndDate(formattedDate);
  }, []);

  const validateForm = () => {
    const errors = {};
    if (!startDate) {
      errors.startDate = "Start Date is required";
    }
    if (!endDate) {
      errors.endDate = "End Date is required";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleApply = async () => {
    if (validateForm()) {
      setLoading(true);
      try {
        const tempStart = startDate.toString();  
        const tempEnd = endDate.toString();   
        NotificationManager.success("Coming Soon.....");
        handleClose();
        return
        await ApplyPaymentsToInvoice(tempStart, tempEnd);
        onApply();
        NotificationManager.success("Payments applied successfully");
        handleClose();
      } catch (error) {
        console.error("Error applying payments:", error);
        NotificationManager.error("Error applying payments");
      } finally {
        setLoading(false);
      }
    }
  };
  

  const handleClose = () => {
    setStartDate("");
    setEndDate("");
    setErrors({});
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Apply Payments</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal" error={!!errors.startDate}>
            <TextField
              label="Start Date"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            {errors.startDate && (
              <FormHelperText>{errors.startDate}</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth margin="normal" error={!!errors.endDate}>
            <TextField
              label="End Date"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            {errors.endDate && (
              <FormHelperText>{errors.endDate}</FormHelperText>
            )}
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleApply}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>

      <CommonLoader loading={loading} />
    </>
  );
};

export default ApplyPaymentsDialog;
